import React from 'react';
import './Games.css';

function Games() {
  const games = [
    {
      name: 'Pick up the Phone [ HORROR ]',
      url: 'https://www.roblox.com/games/72752636672203/Pick-up-the-Phone',
      status: 'Released',
      category: 'Horror',
      description: 'A psychological horror experience inspired by Blackphone 2.'
    },
    {
      name: 'Level 974 – MrKitty\'s Home',
      url: null,
      status: 'In Development',
      category: 'Horror',
      description: 'A Backrooms horror game. We\'re actively working on this project.'
    }
  ];

  return (
    <section className="games-page">
      <div className="container">
        <div className="section-header">
          <h2>Our Games</h2>
          <p>Check out our Roblox experiences</p>
        </div>
        
        <div className="games-grid">
          {games.map((game, index) => (
            <div key={index} className={`game-card ${game.status === 'In Development' ? 'in-dev' : ''}`}>
              <div className="game-status-badge">{game.status}</div>
              <div className="game-category">{game.category}</div>
              <h3 className="game-title">{game.name}</h3>
              <p className="game-description">{game.description}</p>
              {game.url ? (
                <a 
                  href={game.url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="game-button"
                >
                  Play Now
                </a>
              ) : (
                <button className="game-button disabled" disabled>
                  Coming Soon
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Games;
